import React from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const CopyActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  /* <ContentCopyIcon /> */

  return (
    <BaseActionButton {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round">
        <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
      </svg>
    </BaseActionButton>
  );
};

export default CopyActionButton;
